import type { ILogger, LogLevel } from './loggerBase';

/* eslint no-console: 'off' */
const clientLogger: ILogger = {
    error: (message: string, context?: Record<string, any>) => {
        console.error(message, context);
    },
    warn: (message: string, context?: Record<string, any>) => {
        console.warn(message, context);
    },
    info: (message: string, context?: Record<string, any>) => {
        console.info(message, context);
    },
    log: (level: LogLevel, message: string, context?: Record<string, any>) => {
        console.log(level, message, context);
    },
};

export default clientLogger;
